<template>
  <transition name="zoom-in-top">
    <div class="e6-box-layor" v-show="isShowBox">
      <div class="e6-box-top" v-drag>
        <div>{{ title }}</div>
        <i class="e6-icon-delete_line" title="关闭" @click="closeBox(true)"></i>
      </div>
      <slot></slot>
    </div>
  </transition>
</template>

<script>
function getPageSize() {
  try {
    var xScroll; //页面滚动宽度
    var yScroll; //页面滚动高度
    var pageHeight;
    var pageWidth;

    if (window.innerHeight && window.scrollMaxY) {
      xScroll = document.body.scrollWidth;
      yScroll = window.innerHeight + window.scrollMaxY;
    } else if (document.body.scrollHeight > document.body.offsetHeight) {
      xScroll = document.body.scrollWidth;
      yScroll = document.body.scrollHeight;
    } else {
      xScroll = document.body.offsetWidth;
      yScroll = document.body.offsetHeight;
    }

    var windowWidth; //屏幕宽度
    var windowHeight; //屏幕高度

    if (self.innerHeight) {
      // all except Explorer
      windowWidth = self.innerWidth;
      windowHeight = self.innerHeight;
    } else if (
      document.documentElement &&
      document.documentElement.clientHeight
    ) {
      // Explorer 6 Strict Mode
      windowWidth = document.documentElement.clientWidth;
      windowHeight = document.documentElement.clientHeight;
    } else if (document.body) {
      // other Explorers
      windowWidth = document.body.clientWidth;
      windowHeight = document.body.clientHeight;
    }
    /*当页面滚动高度比屏幕高度小的时候，页面高度为屏幕高度，反之，为页面滚动高度*/
    if (yScroll < windowHeight) {
      pageHeight = windowHeight;
    } else {
      pageHeight = yScroll;
    }
    /*当页面滚动宽度比屏幕宽度小的时候，页面宽度为屏幕宽度，反之，为页面滚动宽度*/
    if (xScroll < windowWidth) {
      pageWidth = windowWidth;
    } else {
      pageWidth = xScroll;
    }

    var arrayPageSize = {
      pageWidth: pageWidth,
      pageHeight: pageHeight,
      windowWidth: windowWidth,
      windowHeight: windowHeight
    };
    return arrayPageSize;
  } catch (error) {
    console.log(error);
  }
}
export default {
  name: "e6Box",

  props: {
    title: {
      type: String,
      default: "e6Box"
    }
  },

  data() {
    return {
      isShowBox: false
    };
  },

  methods: {
    showBox() {
      this.isShowBox = true;
    },
    closeBox(isCallback = false) {
      this.isShowBox = false;
      if (isCallback) {
        this.$emit("closeFun");
      }
    }
  },

  directives: {
    drag(el) {
      var wh = getPageSize();
      el.onmousedown = function(e) {
        var disx = e.pageX - el.parentElement.offsetLeft;
        var disy = e.pageY - el.parentElement.offsetTop;
        var h = el.parentElement.offsetHeight;
        var w = el.parentElement.offsetWidth;
        document.onmousemove = function(e) {
          var movex = e.pageX - disx;
          var movey = e.pageY - disy;
          movex =
            movex < 0
              ? 0
              : movex + w > wh.windowWidth
              ? wh.windowWidth - w
              : movex;
          movey =
            movey < 0
              ? 0
              : movey + h + 37 + 45 > wh.windowHeight
              ? wh.windowHeight - h - 37 - 45
              : movey;
          el.parentElement.style.left = movex + "px";
          el.parentElement.style.top = movey + "px";
        };
        document.onmouseup = function() {
          document.onmouseup = document.onmousemove = null;
        };
        e.preventDefault();
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.e6-box-layor {
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 3px;
  position: absolute;
  background-color: #fff;
  z-index: 2002;
  .e6-box-top {
    cursor: move;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-radius: 3px 3px 0 0 !important;
    background: #f8f8f8 !important;
    color: #222;
    font-weight: bold;
    font-size: 12px;
    height: 35px;
    line-height: 35px;
    padding: 0 10px;
    i {
      cursor: pointer;
    }
  }
}
$--md-fade-transition: transform 300ms cubic-bezier(0.23, 1, 0.32, 1),
  opacity 300ms cubic-bezier(0.23, 1, 0.32, 1) !default;
.zoom-in-top-enter-active,
.zoom-in-top-leave-active {
  opacity: 1;
  transform: scaleY(1);
  transition: $--md-fade-transition;
  transform-origin: center top;
}
.zoom-in-top-enter,
.zoom-in-top-leave-active {
  opacity: 0;
  transform: scaleY(0);
}
</style>
